import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import AxiosInstance from "../../AxiosInstance";
import { alertError, alertSuccess } from "../../pages/Helper/Alerts";
import { Progress } from "antd";
import { profileRedirection } from "../../utils";
import newLogo from "../../assets/new_logo.png";
import "./OtherHeader.css";
import { message } from "antd";
const OtherPageHeader = ({
  classProps,
  innerClassProps,
  pageType = "NORMAL",
}) => {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [userData, setUserData] = useState();

  var userName = localStorage.getItem("username");
  async function logOut() {
    await AxiosInstance()
      .post("/auth/signOut", {
        token: localStorage.getItem("token"),
      })
      .then((value) => {
        window.location.href = "/";
        localStorage.clear();
        sessionStorage.clear();
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  }
  useEffect(() => {
    const data = localStorage.getItem("roles");
    if (data) setRoles(data);
  }, [classProps]);

  const insetRole = (role) => {
    const roles = ["POLICY_MASTER", "INVESTOR", "PARTNER"];
    const newRoles = roles.filter((item) => item !== role);
    localStorage.setItem("roles", newRoles.toString());
  };

  useEffect(() => {
    pageType === "NORMAL" && getUserMe();
  }, []);

  const getUserMe = () => {
    const url = "/user/me";
    AxiosInstance()
      .get(url)
      .then((resp) => {
        if (resp.status === 200) {
          localStorage.setItem("id", resp.data.id);
          localStorage.setItem("userId", resp.data.userId);
          setUserData(resp.data);
          console.log(resp.data);
        }
      });
  };

  const switchDashboard = (role) => {
    AxiosInstance()
      .get(`/auth/getNewToken/${role}`)
      .then((resp) => {
        localStorage.setItem("token", resp.data.token);
        insetRole(role);
        switch (role) {
          case "POLICY_MASTER":
            window.location.href = "/phdashboard";
            break;

          case "INVESTOR":
            window.location.href = "/investorDashboard";
            break;
          case "PARTNER":
            window.location.href = "/partnerDashboard";
            break;
          default:
            break;
        }
      })
      .catch((err) => {
        alertError(err.response.data.message);
      });
  };

  const onProgress = () => {
    profileRedirection(
      userData.status,
      userData.currentRole && userData.currentRole,
      navigate
    );
  };

  const getPercentage = () => {
    if (userData) {
      if (userData.status === "NOT_UPDATED") {
        return 20;
      } else if (["PENDING", "PENDING_SUPERVISOR"].includes(userData.status)) {
        return 50;
      } else if (userData.status === "APPROVED") {
        return 100;
      }
    }
  };
  const navigateHome = () => {
    switch (userData.currentRole) {
      case "INVESTOR":
        console.log(userData.currentRole);
        window.location.href = "/investorDashboard";
        // navigate("/investorDashboard");
        break;
      case "PARTNER":
        window.location.href = "/partnerDashboard";
        // navigate("/partnerDashboard");
        break;
      case "POLICY_MASTER":
        window.location.href = "/phDashboard";
        // navigate("/phDashboard");
        break;

      default:
        break;
    }
  };

  return (
    <header className={classProps}>
      <div className="container mt-1">
        <nav
          className={`navbar navbar-expand-lg bg-white static-top ${innerClassProps}`}
        >
          <div className="container align-items-center">
            <Link className="navbar-brand" onClick={navigateHome}>
              <img src={newLogo} className="headerLogo" alt="" />
              {/* <TPELogo /> */}
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ms-auto header-menu">
                <li
                  className="nav-item dropdown"
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <Link
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingRight: 12,
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div
                        onClick={onProgress}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "40px",
                        }}
                      >
                        <Progress
                          showInfo={false}
                          type="dashboard"
                          strokeColor={
                            // { "0%": "#108ee9", "100%": "#87d068" }
                            getPercentage() === 100 ? "#49D3B0" : "#1677ff"
                          }
                          strokeLinecap="butt"
                          percent={getPercentage()}
                          size={38}
                        />
                        <img
                          style={{ position: "absolute" }}
                          src="https://images-stage.thepolicyexchange.com/platform/avatar.webp"
                          height={30}
                          alt=""
                        />
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          top: "37px",
                          background:
                            getPercentage() === 100 ? "#49D3B0" : "#1677ff",
                          borderRadius: "10px",
                          padding: "0px 7px 1px 7px",
                          fontSize: "8px",
                          color: "white",
                          border: "2px solid white",
                        }}
                      >
                        {getPercentage() < 100
                          ? "Complete profile"
                          : getPercentage()}
                      </div>
                    </div>

                    <span
                      className="px-2"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: "130px",
                      }}
                    >
                      {userName}
                    </span>
                  </Link>
                  {userData?.currentRole === "PARTNER" && (
                    <span
                      onClick={() => {
                        navigator.clipboard.writeText(userData?.referralCode);
                        alertSuccess("Referal Code Copied");
                      }}
                      style={{
                        cursor: "pointer",
                        fontSize: "10px",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {" "}
                      Partner Code: {userData?.referralCode}
                    </span>
                  )}
                  <ul
                    className="dropdown-menu dropdown-menu-end"
                    aria-labelledby="navbarDropdown"
                    style={{ minWidth: "180px" }}
                  >
                    {userData?.currentRole === "PARTNER" && (
                      <li>
                        <Link
                          className="dropdown-item"
                          onClick={() => {
                            navigator.clipboard.writeText(
                              userData?.referralCode
                            );
                            alertSuccess("Referal Code Copied");
                          }}
                        >
                          Copy Referral Code
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link
                        className="dropdown-item"
                        onClick={() => {
                          window.location.href = "/profile";
                        }}
                      >
                        My Profile
                      </Link>
                    </li>
                    {roles.includes("POLICY_MASTER") && (
                      <li>
                        <Link
                          className="dropdown-item"
                          onClick={() => {
                            switchDashboard("POLICY_MASTER");
                          }}
                        >
                          Switch to Policy Holder
                        </Link>
                      </li>
                    )}
                    {roles.includes("INVESTOR") && (
                      <li>
                        <Link
                          className="dropdown-item"
                          onClick={() => {
                            switchDashboard("INVESTOR");
                          }}
                        >
                          Switch to Investor
                        </Link>
                      </li>
                    )}
                    {roles.includes("PARTNER") && (
                      <li>
                        <Link
                          className="dropdown-item"
                          onClick={() => {
                            switchDashboard("PARTNER");
                          }}
                        >
                          Switch to Partner
                        </Link>
                      </li>
                    )}
                    {/* <li>
                      <Link className="dropdown-item" onClick={()=>{ window.location.href='/profile'}}>
                        My Profile
                      </Link>
                    </li> */}
                    <li>
                      <Link className="dropdown-item" onClick={logOut}>
                        Logout
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default OtherPageHeader;
